// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"9d5235d0","453":"d22d749a"}[chunkId] + ".chunk.js";
};